/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */
/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */
// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript';
// @ts-ignore
import request from "./request";
const mockUrl_0_0_0_0 = "http://yapi.yishou.com/mock/128";
const devUrl_0_0_0_0 = "http://erp38.yishou.com/";
const prodUrl_0_0_0_0 = "";
const dataKey_0_0_0_0 = "data";
/**
 * 接口 [波次单筛选条件补充↗](http://yapi.yishou.com/project/128/interface/api/33373) 的 **请求配置**
 *
 * @分类 [波次单↗](http://yapi.yishou.com/project/128/interface/api/cat_2668)
 * @请求头 `GET /erp/WavePicking/getWavePickingCondition`
 * @更新时间 `2022-06-13 16:42:10`
 */
const getWavePickingConditionRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/WavePicking/getWavePickingCondition",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {
        type: "object",
        properties: {
            hg_show_id: {
                type: "array",
                items: {
                    type: "object",
                    properties: { hg_id: { type: "string" }, hg_show_id: { type: "string" } },
                    required: ["hg_id", "hg_show_id"],
                },
                description: "中分位分组",
            },
            category: {
                type: "array",
                items: {
                    type: "object",
                    properties: { cat_name: { type: "string" }, cat_id: { type: "string" } },
                    required: ["cat_name", "cat_id"],
                },
            },
            logistics: {
                type: "array",
                items: {
                    type: "object",
                    properties: { logistics_id: { type: "string" }, logistics_name: { type: "string" } },
                    required: ["logistics_id", "logistics_name"],
                },
            },
            province: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        region_id: { type: "string" },
                        parent_id: { type: "string" },
                        region_name: { type: "string" },
                        region_type: { type: "string" },
                        agency_id: { type: "string" },
                        auto_time: { type: "string" },
                    },
                    required: ["region_id", "parent_id", "region_name", "region_type", "agency_id", "auto_time"],
                },
            },
            status: {
                type: "array",
                items: {
                    type: "object",
                    properties: { status_id: { type: "number" }, status_name: { type: "string" } },
                    required: ["status_id", "status_name"],
                },
            },
            type: {
                type: "array",
                items: {
                    type: "object",
                    properties: { type_id: { type: "number" }, type_name: { type: "string" } },
                    required: ["type_id", "type_name"],
                },
            },
            senders: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        shipping_company: { type: "string" },
                        sender: { type: "string" },
                        sender_id: { type: "string" },
                    },
                    required: ["shipping_company", "sender", "sender_id"],
                },
            },
            as_type: {
                type: "array",
                items: {
                    type: "object",
                    properties: { type_id: { type: "number" }, type_name: { type: "string" } },
                    required: ["type_id", "type_name"],
                },
            },
            picking_type: {
                type: "array",
                items: {
                    type: "object",
                    properties: { type_id: { type: "number" }, type_name: { type: "string" } },
                    required: ["type_id", "type_name"],
                },
            },
            picking_model: {
                type: "array",
                items: {
                    type: "object",
                    properties: { type_id: { type: "number" }, type_name: { type: "string" } },
                    required: ["type_id", "type_name"],
                },
            },
            is_stock: {
                type: "array",
                items: {
                    type: "object",
                    properties: { id: { type: "number" }, name: { type: "string" } },
                    required: ["id", "name"],
                },
            },
            same_day_shipping: {
                type: "array",
                items: {
                    type: "object",
                    properties: { id: { type: "number" }, name: { type: "string" } },
                    required: ["id", "name"],
                },
            },
            has_spot_order: {
                type: "array",
                items: {
                    type: "object",
                    properties: { id: { type: "number" }, name: { type: "string" } },
                    required: ["id", "name"],
                },
            },
            is_stop_shipping: {
                type: "array",
                items: {
                    type: "object",
                    properties: { id: { type: "number" }, name: { type: "string" } },
                    required: ["id", "name"],
                },
            },
            origin: {
                type: "array",
                items: {
                    type: "object",
                    properties: { origin_id: { type: "number" }, origin_name: { type: "string" } },
                    required: ["origin_id", "origin_name"],
                },
            },
            user_origin: { type: "number" },
            express: { type: "array", items: { type: "string" } },
            all_express: { type: "array", items: { type: "string" } },
            generate_picking_task: {
                type: "array",
                items: {
                    type: "object",
                    properties: { key: { type: "number" }, value: { type: "string" } },
                    required: ["key", "value"],
                },
            },
            print_status: {
                type: "array",
                items: {
                    type: "object",
                    properties: { id: { type: "number" }, name: { type: "string" } },
                    required: ["id", "name"],
                },
            },
            market: {
                type: "array",
                items: {
                    type: "object",
                    properties: { key: { type: "string" }, label: { type: "string" }, show_brand: { type: "string" } },
                    required: ["key", "label", "show_brand"],
                },
            },
            two_type: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        value: { type: "string" },
                        label: { type: "string" },
                        children: {
                            type: "array",
                            items: {
                                type: "object",
                                properties: { value: { type: "string" }, label: { type: "string" } },
                                required: ["value", "label"],
                            },
                        },
                    },
                    required: ["value", "label", "children"],
                },
            },
            user_net_worth_type: {
                type: "array",
                items: {
                    type: "object",
                    properties: { value: { type: "string" }, label: { type: "string" } },
                    required: ["value", "label"],
                },
            },
        },
    },
    requestFunctionName: "getWavePickingCondition",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [波次单筛选条件补充↗](http://yapi.yishou.com/project/128/interface/api/33373) 的 **请求函数**
 *
 * @分类 [波次单↗](http://yapi.yishou.com/project/128/interface/api/cat_2668)
 * @请求头 `GET /erp/WavePicking/getWavePickingCondition`
 * @更新时间 `2022-06-13 16:42:10`
 */
export const getWavePickingCondition = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getWavePickingConditionRequestConfig, requestData), ...args);
};
getWavePickingCondition.requestConfig = getWavePickingConditionRequestConfig;
/**
 * 接口 [打印新面单（重打）↗](http://yapi.yishou.com/project/128/interface/api/33387) 的 **请求配置**
 *
 * @分类 [波次单↗](http://yapi.yishou.com/project/128/interface/api/cat_2668)
 * @请求头 `POST /erp/WavePickingExpress/updateExpress`
 * @更新时间 `2022-04-19 11:15:45`
 */
const updateExpressRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/WavePickingExpress/updateExpress",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["wave_picking_id", "express", "sender_id"],
        properties: {
            wave_picking_id: { type: "string", description: "波次单ID" },
            express: { type: "string", description: "快递公司" },
            sender_id: { type: "string", description: "网点ID" },
        },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            cmd: { type: "string", description: '"print"' },
            requestID: { type: "string", description: '"1650335818_printWayBillOfMany"' },
            version: { type: "string", description: '"1.0"' },
            task: {
                type: "object",
                properties: {
                    taskID: { type: "string", description: '"1650335818_0_printWayBillOfMany"' },
                    preview: { type: "boolean" },
                    previewType: { type: "string" },
                    firstDocumentNumber: { type: "integer", description: "1" },
                    totalDocumentCount: { type: "integer", description: "1" },
                    documents: {
                        type: "array",
                        items: {
                            type: "object",
                            properties: {
                                documentID: { type: "string", description: '"1650335818_0"' },
                                contents: {
                                    type: "array",
                                    items: {
                                        type: "object",
                                        properties: {
                                            data: {
                                                type: "object",
                                                properties: {
                                                    _dataFrom: { type: "string", description: '"waybill"' },
                                                    adsInfo: {
                                                        type: "object",
                                                        properties: {
                                                            adId: { type: "string", description: '"3"' },
                                                            advertisementType: { type: "string", description: '"PSA"' },
                                                            bannerUrl: {
                                                                type: "string",
                                                                description: '"http://ad-cdn.cainiao.com/3/1570692360541.jpg"',
                                                            },
                                                            miniBannerUrl: {
                                                                type: "string",
                                                                description: '"http://ad-cdn.cainiao.com/3/1570692349536.jpg"',
                                                            },
                                                        },
                                                        additionalProperties: false,
                                                    },
                                                    cpCode: { type: "string", description: '"ZTO"' },
                                                    needEncrypt: { type: "boolean" },
                                                    packageInfo: {
                                                        type: "object",
                                                        properties: {
                                                            items: {
                                                                type: "array",
                                                                items: {
                                                                    type: "object",
                                                                    properties: {
                                                                        count: { type: "integer", description: "2" },
                                                                        name: { type: "string", description: '"衣服"' },
                                                                    },
                                                                    additionalProperties: false,
                                                                },
                                                                description: '[{"count":2,"name":"衣服"}]',
                                                            },
                                                        },
                                                        additionalProperties: false,
                                                    },
                                                    parent: { type: "boolean" },
                                                    recipient: {
                                                        type: "object",
                                                        properties: {
                                                            address: {
                                                                type: "object",
                                                                properties: {
                                                                    city: { type: "string", description: '"蚌埠市"' },
                                                                    detail: { type: "string", description: '"1008"' },
                                                                    district: { type: "string", description: '"中市区"' },
                                                                    province: { type: "string", description: '"安徽省"' },
                                                                },
                                                                additionalProperties: false,
                                                            },
                                                            name: { type: "string", description: '"小晓如10087"' },
                                                            phone: { type: "string", description: '"155****3002"' },
                                                        },
                                                        additionalProperties: false,
                                                    },
                                                    routingInfo: {
                                                        type: "object",
                                                        properties: {
                                                            blockCode: { type: "string", description: '"中市区"' },
                                                            consolidation: {
                                                                type: "object",
                                                                properties: { name: { type: "string", description: '"蚌埠转"' } },
                                                                additionalProperties: false,
                                                            },
                                                            origin: {
                                                                type: "object",
                                                                properties: {
                                                                    code: { type: "string", description: '"02036"' },
                                                                    name: { type: "string", description: '"广州永福"' },
                                                                },
                                                                additionalProperties: false,
                                                            },
                                                            receiveBranch: {
                                                                type: "object",
                                                                properties: {
                                                                    code: { type: "string", description: '"55210"' },
                                                                    name: { type: "string", description: '"蚌埠"' },
                                                                },
                                                                additionalProperties: false,
                                                            },
                                                            routeCode: { type: "string", description: '"01 "' },
                                                            sortation: {
                                                                type: "object",
                                                                properties: { name: { type: "string", description: '"471-"' } },
                                                                additionalProperties: false,
                                                            },
                                                            startCenter: { type: "array", description: "[]" },
                                                            terminalCenter: { type: "array", description: "[]" },
                                                        },
                                                        additionalProperties: false,
                                                    },
                                                    sender: {
                                                        type: "object",
                                                        properties: {
                                                            address: {
                                                                type: "object",
                                                                properties: {
                                                                    city: { type: "string", description: '"广州市"' },
                                                                    detail: { type: "string", description: '"1号仓"' },
                                                                    district: { type: "string", description: '"其它区"' },
                                                                    province: { type: "string", description: '"广东省"' },
                                                                },
                                                                additionalProperties: false,
                                                            },
                                                            name: { type: "string", description: '"蒋小爱广州11"' },
                                                            phone: { type: "string", description: '"****7343"' },
                                                        },
                                                        additionalProperties: false,
                                                    },
                                                    shippingOption: {
                                                        type: "object",
                                                        properties: {
                                                            code: { type: "string", description: '"STANDARD_EXPRESS"' },
                                                            title: { type: "string", description: '"标准快递"' },
                                                        },
                                                        additionalProperties: false,
                                                    },
                                                    waybillCode: { type: "string", description: '"75871745811071"' },
                                                },
                                                additionalProperties: false,
                                            },
                                            signature: { type: "string", description: '"MD:xbW/mXa/WVFfzuKARZF2lA=="' },
                                            templateURL: {
                                                type: "string",
                                                description: '"http://cloudprint.cainiao.com/template/standard/287267/3"',
                                            },
                                        },
                                        additionalProperties: false,
                                    },
                                    description: '[{"data":{"_dataFrom":"waybill","adsInfo":{"adId":"3","advertisementType":"PSA","bannerUrl":"http://ad-cdn.cainiao.com/3/1570692360541.jpg","miniBannerUrl":"http://ad-cdn.cainiao.com/3/1570692349536.jpg"},"cpCode":"ZTO","needEncrypt":false,"packageInfo":{"items":[{"count":2,"name":"衣服"}]},"parent":false,"recipient":{"address":{"city":"蚌埠市","detail":"1008","district":"中市区","province":"安徽省"},"name":"小晓如10087","phone":"155****3002"},"routingInfo":{"blockCode":"中市区","consolidation":{"name":"蚌埠转"},"origin":{"code":"02036","name":"广州永福"},"receiveBranch":{"code":"55210","name":"蚌埠"},"routeCode":"01 ","sortation":{"name":"471-"},"startCenter":[],"terminalCenter":[]},"sender":{"address":{"city":"广州市","detail":"1号仓","district":"其它区","province":"广东省"},"name":"蒋小爱广州11","phone":"****7343"},"shippingOption":{"code":"STANDARD_EXPRESS","title":"标准快递"},"waybillCode":"75871745811071"},"signature":"MD:xbW/mXa/WVFfzuKARZF2lA==","templateURL":"http://cloudprint.cainiao.com/template/standard/287267/3"}]',
                                },
                            },
                            additionalProperties: false,
                        },
                        description: '[{"documentID":"1650335818_0","contents":[{"data":{"_dataFrom":"waybill","adsInfo":{"adId":"3","advertisementType":"PSA","bannerUrl":"http://ad-cdn.cainiao.com/3/1570692360541.jpg","miniBannerUrl":"http://ad-cdn.cainiao.com/3/1570692349536.jpg"},"cpCode":"ZTO","needEncrypt":false,"packageInfo":{"items":[{"count":2,"name":"衣服"}]},"parent":false,"recipient":{"address":{"city":"蚌埠市","detail":"1008","district":"中市区","province":"安徽省"},"name":"小晓如10087","phone":"155****3002"},"routingInfo":{"blockCode":"中市区","consolidation":{"name":"蚌埠转"},"origin":{"code":"02036","name":"广州永福"},"receiveBranch":{"code":"55210","name":"蚌埠"},"routeCode":"01 ","sortation":{"name":"471-"},"startCenter":[],"terminalCenter":[]},"sender":{"address":{"city":"广州市","detail":"1号仓","district":"其它区","province":"广东省"},"name":"蒋小爱广州11","phone":"****7343"},"shippingOption":{"code":"STANDARD_EXPRESS","title":"标准快递"},"waybillCode":"75871745811071"},"signature":"MD:xbW/mXa/WVFfzuKARZF2lA==","templateURL":"http://cloudprint.cainiao.com/template/standard/287267/3"}]}]',
                    },
                },
                additionalProperties: false,
            },
        },
        additionalProperties: false,
    },
    requestFunctionName: "updateExpress",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [打印新面单（重打）↗](http://yapi.yishou.com/project/128/interface/api/33387) 的 **请求函数**
 *
 * @分类 [波次单↗](http://yapi.yishou.com/project/128/interface/api/cat_2668)
 * @请求头 `POST /erp/WavePickingExpress/updateExpress`
 * @更新时间 `2022-04-19 11:15:45`
 */
export const updateExpress = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(updateExpressRequestConfig, requestData), ...args);
};
updateExpress.requestConfig = updateExpressRequestConfig;
/**
 * 接口 [波次单列表↗](http://yapi.yishou.com/project/128/interface/api/33603) 的 **请求配置**
 *
 * @分类 [波次单↗](http://yapi.yishou.com/project/128/interface/api/cat_2668)
 * @请求头 `POST /erp/WavePicking/getWavePickingList`
 * @更新时间 `2022-06-20 11:35:13`
 */
const getWavePickingListRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/WavePicking/getWavePickingList",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: [
            "order_create_time[0]",
            "order_create_time[1]",
            "create_time[0]",
            "create_time[1]",
            "log_time[0]",
            "log_time[1]",
            "label_time[0]",
            "label_time[1]",
            "gp_time[0]",
            "gp_time[1]",
            "note_without_num",
            "dbid",
            "is_pu",
            "remark_wave_picking_id",
            "change_shipping_company",
            "change_shipping_num",
            "pagesize",
            "remark",
            "picking_assignment_no",
            "change_consignee",
            "change_wave_picking_mobile_hide",
            "change_province",
            "change_city",
            "change_district",
            "change_address",
            "user_search",
            "page",
            "wave_picking_no",
            "sku",
            "order_sn",
            "goods_no",
            "user_id",
            "mobile",
            "shipping_num",
            "quality_label_summary_id",
            "is_pc",
            "hgd_id[0]",
            "hgd_id[1]",
            "user_net_worth_type",
        ],
        properties: {
            "order_create_time[0]": { type: "string", description: "" },
            "order_create_time[1]": { type: "string", description: "" },
            "create_time[0]": { type: "string", description: "" },
            "create_time[1]": { type: "string", description: "" },
            "log_time[0]": { type: "string", description: "" },
            "log_time[1]": { type: "string", description: "" },
            "label_time[0]": { type: "string", description: "" },
            "label_time[1]": { type: "string", description: "" },
            "gp_time[0]": { type: "string", description: "" },
            "gp_time[1]": { type: "string", description: "" },
            note_without_num: { type: "string", description: "" },
            dbid: { type: "string", description: "" },
            is_pu: { type: "string", description: "" },
            remark_wave_picking_id: { type: "string", description: "" },
            change_shipping_company: { type: "string", description: "" },
            change_shipping_num: { type: "string", description: "" },
            pagesize: { type: "string", description: "" },
            remark: { type: "string", description: "" },
            picking_assignment_no: { type: "string", description: "" },
            change_consignee: { type: "string", description: "" },
            change_wave_picking_mobile_hide: { type: "string", description: "" },
            change_province: { type: "string", description: "" },
            change_city: { type: "string", description: "" },
            change_district: { type: "string", description: "" },
            change_address: { type: "string", description: "" },
            user_search: { type: "string", description: "" },
            page: { type: "string", description: "" },
            wave_picking_no: { type: "string", description: "" },
            sku: { type: "string", description: "" },
            order_sn: { type: "string", description: "" },
            goods_no: { type: "string", description: "" },
            user_id: { type: "string", description: "" },
            mobile: { type: "string", description: "" },
            shipping_num: { type: "string", description: "" },
            quality_label_summary_id: { type: "string", description: "" },
            is_pc: { type: "string", description: "" },
            "hgd_id[0]": { type: "string", description: "中分位id数组" },
            "hgd_id[1]": { type: "string", description: "" },
            user_net_worth_type: { type: "string", description: "用户净值标签数组" },
        },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            total: { type: "number" },
            info_total: { type: "number" },
            sku_num: { type: "number" },
            data: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        wave_picking_id: { type: "string" },
                        wave_picking_no: { type: "string" },
                        user_id: { type: "string" },
                        address: { type: "string" },
                        province_text: { type: "string" },
                        city_text: { type: "string" },
                        district_text: { type: "string" },
                        province: { type: "string" },
                        city: { type: "string" },
                        district: { type: "string" },
                        consignee: { type: "string" },
                        shipping_company: { type: "string" },
                        shipping_num: { type: "string" },
                        wave_picking_num: { type: "string" },
                        weight: { type: "string" },
                        update_time: { type: "string" },
                        create_time: { type: "string" },
                        status: { type: "string" },
                        pay_way: { type: "string" },
                        print_status: { type: "string" },
                        wave_picking_pay_way: { type: "string" },
                        wave_picking_status: { type: "string" },
                        wave_picking_print_status: { type: "string" },
                        wave_picking_mobile_hide: { type: "string" },
                        order_sn: { type: "array", items: { type: "string" } },
                        order_id: { type: "string" },
                        custom_note: { type: "array", items: { type: "string" } },
                        admin_note: { type: "array", items: { type: "string" } },
                        is_other: { type: "string" },
                        is_change_address: { type: "string" },
                        is_merge_order: { type: "string" },
                        is_change_express: { type: "string" },
                        is_send_logistics: { type: "string" },
                        is_no_invoice: { type: "string" },
                        is_change_consignee: { type: "string" },
                        is_quality_testing: { type: "string" },
                        is_delivery: { type: "string" },
                        is_delivery_formal: { type: "string" },
                        is_goods_explode_delivery: { type: "string" },
                        is_stock: { type: "string" },
                        is_stop_shipping: { type: "string" },
                        wave_picking_full_allot: { type: "string" },
                        full_allot: { type: "string" },
                        wave_picking_picking_type: { type: "string" },
                        wave_picking_is_put_picking_list: { type: "string" },
                        wave_picking_is_stop_shipping: { type: "string" },
                        wave_picking_is_stock: { type: "string" },
                        wave_picking_is_generate_picking_task: { type: "string" },
                        wave_picking_type: { type: "string" },
                        type: { type: "string" },
                        is_remark: { type: "string" },
                        ck_remark: { type: "string" },
                        out_time: { type: "string" },
                        sk_content: { type: "null" },
                        sk_time: { type: "string" },
                        shipping_info_by_storage_status: { type: "string" },
                        sender_type: { type: "string" },
                        sender: { type: "string" },
                        wp_out_time: { type: "string" },
                        origin: { type: "string" },
                        storehouse_id: { type: "string" },
                        wave_picking_ext_same_day_shipping: { type: "string" },
                        quality_level: { type: "string" },
                        express_account_id: { type: "string" },
                        pre_weight: { type: "string" },
                        rec_ids: { type: "string" },
                        order_rec: { type: "string" },
                        hg_show_id: { type: "string" },
                        hg_code: { type: "string", description: "中分位编号" },
                        wave_picking_origin: { type: "string" },
                        shipping_kdniao_state: { type: "string" },
                    },
                    required: [
                        "wave_picking_id",
                        "wave_picking_no",
                        "user_id",
                        "address",
                        "province_text",
                        "city_text",
                        "district_text",
                        "province",
                        "city",
                        "district",
                        "consignee",
                        "shipping_company",
                        "shipping_num",
                        "wave_picking_num",
                        "weight",
                        "update_time",
                        "create_time",
                        "status",
                        "pay_way",
                        "print_status",
                        "wave_picking_pay_way",
                        "wave_picking_status",
                        "wave_picking_print_status",
                        "wave_picking_mobile_hide",
                        "order_sn",
                        "order_id",
                        "custom_note",
                        "admin_note",
                        "is_other",
                        "is_change_address",
                        "is_merge_order",
                        "is_change_express",
                        "is_send_logistics",
                        "is_no_invoice",
                        "is_change_consignee",
                        "is_quality_testing",
                        "is_delivery",
                        "is_delivery_formal",
                        "is_goods_explode_delivery",
                        "is_stock",
                        "is_stop_shipping",
                        "wave_picking_full_allot",
                        "full_allot",
                        "wave_picking_picking_type",
                        "wave_picking_is_put_picking_list",
                        "wave_picking_is_stop_shipping",
                        "wave_picking_is_stock",
                        "wave_picking_is_generate_picking_task",
                        "wave_picking_type",
                        "type",
                        "is_remark",
                        "ck_remark",
                        "out_time",
                        "sk_content",
                        "sk_time",
                        "shipping_info_by_storage_status",
                        "sender_type",
                        "sender",
                        "wp_out_time",
                        "origin",
                        "storehouse_id",
                        "wave_picking_ext_same_day_shipping",
                        "quality_level",
                        "express_account_id",
                        "pre_weight",
                        "rec_ids",
                        "order_rec",
                        "hg_show_id",
                        "hg_code",
                        "wave_picking_origin",
                        "shipping_kdniao_state",
                    ],
                },
            },
            wait_allot_order_sn: { type: "array", items: { type: "string" } },
            spot_order_sn: { type: "array", items: { type: "string" } },
            prior_order_sn: { type: "array", items: { type: "string" } },
            setting: { type: "string" },
            origin: { type: "number" },
            need_time: { type: "array", items: { type: "boolean" } },
        },
    },
    requestFunctionName: "getWavePickingList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [波次单列表↗](http://yapi.yishou.com/project/128/interface/api/33603) 的 **请求函数**
 *
 * @分类 [波次单↗](http://yapi.yishou.com/project/128/interface/api/cat_2668)
 * @请求头 `POST /erp/WavePicking/getWavePickingList`
 * @更新时间 `2022-06-20 11:35:13`
 */
export const getWavePickingList = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getWavePickingListRequestConfig, requestData), ...args);
};
getWavePickingList.requestConfig = getWavePickingListRequestConfig;
/**
 * 接口 [导出尾货折销模板↗](http://yapi.yishou.com/project/128/interface/api/33647) 的 **请求配置**
 *
 * @分类 [波次单↗](http://yapi.yishou.com/project/128/interface/api/cat_2668)
 * @请求头 `POST /erp/WavePicking/exportDiscountFile`
 * @更新时间 `2022-06-15 09:52:49`
 */
const exportDiscountFileRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/WavePicking/exportDiscountFile",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: { type: "object", required: [], properties: {} },
    responseDataJsonSchema: {},
    requestFunctionName: "exportDiscountFile",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [导出尾货折销模板↗](http://yapi.yishou.com/project/128/interface/api/33647) 的 **请求函数**
 *
 * @分类 [波次单↗](http://yapi.yishou.com/project/128/interface/api/cat_2668)
 * @请求头 `POST /erp/WavePicking/exportDiscountFile`
 * @更新时间 `2022-06-15 09:52:49`
 */
export const exportDiscountFile = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(exportDiscountFileRequestConfig, requestData), ...args);
};
exportDiscountFile.requestConfig = exportDiscountFileRequestConfig;
/**
 * 接口 [根据导入文件生成尾货折销波次出库↗](http://yapi.yishou.com/project/128/interface/api/33648) 的 **请求配置**
 *
 * @分类 [波次单↗](http://yapi.yishou.com/project/128/interface/api/cat_2668)
 * @请求头 `POST /erp/WavePicking/importDiscountWavePickingByDbid`
 * @更新时间 `2022-06-15 09:54:12`
 */
const importDiscountWavePickingByDbidRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/WavePicking/importDiscountWavePickingByDbid",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["excel", "order_id"],
        properties: {
            excel: { type: "file", description: "导入文件", tsType: "FileData" },
            order_id: { type: "string", description: "折销订单id" },
        },
    },
    responseDataJsonSchema: { type: "string" },
    requestFunctionName: "importDiscountWavePickingByDbid",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [根据导入文件生成尾货折销波次出库↗](http://yapi.yishou.com/project/128/interface/api/33648) 的 **请求函数**
 *
 * @分类 [波次单↗](http://yapi.yishou.com/project/128/interface/api/cat_2668)
 * @请求头 `POST /erp/WavePicking/importDiscountWavePickingByDbid`
 * @更新时间 `2022-06-15 09:54:12`
 */
export const importDiscountWavePickingByDbid = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(importDiscountWavePickingByDbidRequestConfig, requestData), ...args);
};
importDiscountWavePickingByDbid.requestConfig = importDiscountWavePickingByDbidRequestConfig;
/**
 * 接口 [导入快递信息前校验↗](http://yapi.yishou.com/project/128/interface/api/33682) 的 **请求配置**
 *
 * @分类 [波次单↗](http://yapi.yishou.com/project/128/interface/api/cat_2668)
 * @请求头 `POST /erp/WavePicking/beforeImportDiscountWavePickingByDbid`
 * @更新时间 `2022-06-20 15:47:53`
 */
const beforeImportDiscountWavePickingByDbidRequestConfig = 
/*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/WavePicking/beforeImportDiscountWavePickingByDbid",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["excel", "order_id"],
        properties: {
            excel: { type: "file", description: "导入文件", tsType: "FileData" },
            order_id: { type: "string", description: "折消订单ID" },
        },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: { beSendNum: { type: "integer", description: "4" }, fileNum: { type: "integer", description: "6" } },
        additionalProperties: false,
    },
    requestFunctionName: "beforeImportDiscountWavePickingByDbid",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [导入快递信息前校验↗](http://yapi.yishou.com/project/128/interface/api/33682) 的 **请求函数**
 *
 * @分类 [波次单↗](http://yapi.yishou.com/project/128/interface/api/cat_2668)
 * @请求头 `POST /erp/WavePicking/beforeImportDiscountWavePickingByDbid`
 * @更新时间 `2022-06-20 15:47:53`
 */
export const beforeImportDiscountWavePickingByDbid = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(beforeImportDiscountWavePickingByDbidRequestConfig, requestData), ...args);
};
beforeImportDiscountWavePickingByDbid.requestConfig = beforeImportDiscountWavePickingByDbidRequestConfig;
/* prettier-ignore-end */



// WEBPACK FOOTER //
// ./src/controller/wavePick.js